<template>
  <div
    v-if="!hideContent"
    ref="form"
    class="form"
    :class="{'en-form': isEnglish}"
  >
    <div class="containerScroll">
      <a-form
        v-if="formData"
        :form="form"
      >
        <div
          v-for="(modules, k) in formData"
          :id="`anchor_${modules.fieldkey}`"
          :key="k"
          :data-key="modules.fieldkey"
        >
          <div
            v-if="modules && modules.child && k !== 'audit_info'"
            class="module"
            :class="{ 'hide': hideModule(k) }"
          >
            <h2 class="title">
              {{ modules.fieldname }}
            </h2>
            <p
              v-if="k === 'base_info'"
              class="recycle-rule-tips fs-warning"
            >
              {{ recycleRuleTips }}
            </p>
            <!-- 信息来源部分特殊处理 start -->
            <!-- <template v-if="modules.fieldkey === 'from_info'">
              <my-item
                v-if="modules.child && modules.child[0] && modules.isedit"
                :value="currentFrom"
                :data="modules"
                class="clearfix"
                @change="handleChangeFromSource($event, data)"
              />

              <not-can-edit-item
                v-if="!modules.isedit"
                :data="fromNotEditItem"
              />
              <template v-if="currentFrom">
                <my-item
                  v-for="(item) in modules.childObj && modules.childObj[currentFrom] && modules.childObj[currentFrom].child"
                  :id="item.fieldkey"
                  :key="item.fieldkey"
                  class="clearfix"
                  :data="item"
                  :modules-data="modules"
                  :current-from="currentFrom"
                  @delete="handleDeleteItem"
                />
              </template>
            </template> -->
            <!-- 信息来源部分特殊处理 end -->

            <!-- 表单循环的主题部分 start -->
            <template>
              <my-item
                v-for="(item) in modules.child"
                v-show="item.fieldtype"
                :id="item.fieldkey"
                :ref="`item_${item.fieldkey}`"
                :key="item.fieldkey"
                class="clearfix"
                :data="item"
                :modules-data="modules"
                @change="handleChangeItem($event, item)"
                @delete="handleDeleteItem"
              />
            </template>
          <!-- 表单循环的主题部分 end -->
          </div>
        </div>
      </a-form>
    </div>
    <!-- 表单按钮 start -->
    <div
      v-if="showFooter"
      class="footer-wrap"
    >
      <div
        v-if="permissionInfo"
        ref="formFooter"
        class="footer"
      >
        <!-- 状态是 待审核，按钮显示 通过，拒审 -->
        <a-button
          v-if="permissionInfo.is_show_approval"
          type="primary"
          :loading="confirmLoading"
          @click="handleSubmit(saveType = 'pass')"
        >
          {{ $t('message["1206"]') }}
        </a-button>
        <!--  -->
        <a-button
          v-if="permissionInfo.is_show_reject"
          @click="confirmReject(saveType = 'reject')"
        >
          {{ $t('message["542"]') }}
        </a-button>
        <!-- 状态是 已拒审，按钮显示 重新通过 -->
        <a-button
          v-if="!showPassTab && permissionInfo.is_show_reapproval"
          type="primary"
          :loading="confirmLoading"
          @click="handleSubmit(saveType = 'pass')"
        >
          {{ $t('message["1624"]') }}
        </a-button>
        <!-- 状态是已通过，且通过信息列表和查重进入详情页，按钮显示 保存 -->
        <a-button
          v-if="permissionInfo.is_show_save"
          type="primary"
          :loading="confirmLoading"
          @click="handleSubmit(saveType = 'save')"
        >
          {{ $t('message["21"]') }}
        </a-button>
        <a-button
          v-if="!showPassTab && permissionInfo && permissionInfo.is_show_del"
          type="danger"
          @click="handleDelete"
        >
          {{ $t('message["962"]') }}
        </a-button>
        <!--  -->
        <div
          v-if="permissionInfo.is_show_compare"
          class="format-history"
        >
          <span class="prompt-text">{{ $t('message["344"]') }}</span>
          <a-button
            ref="formatHistoryBtn"
            class="format-history-btn"
            @click="handleFormatHistory"
          >
            {{ $t('message["88"]') }}
          </a-button>
        </div>
      </div>
    </div>
    <!-- 表单按钮 end -->
    <reject-modal
      :visible.sync="showRejectModal"
      :inquiry-id="inquiryId"
      :audit-roleid="rejectAuditRoleid"
      :audit-groupid="rejectAuditGroupid"
    />
    <repeat-modal
      :visible.sync="showRepeatModal"
      :inquiry-id="inquiryId"
      :data="repeatData"
      :save-type="saveType"
      :again-save-form="againSaveForm"
    />
    <format-history-modal
      v-if="permissionInfo.is_show_compare"
      :visible.sync="showFormatHistoryModal"
      :form-history-id="formHistoryId"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import inquiryFormMixin from '@/lib/inquiryFormMixin'
import { inquiryEdit, inquiryApproval } from '@/services/inqueryServices'
import MyItem from './../formItem/Item'
// import NotCanEditItem from './../formItem/NotCanEdit'
import RejectModal from './modal/RejectModal'
import RepeatModal from './modal/RepeatModal'
import FormatHistoryModal from './modal/FormatHistoryModal'
import eventBus from '@/lib/eventBus'
import { getLang } from '@/lib/storage'

const FROM_SOPURCE = 'notice'

export default {
  components: {
    MyItem,
    // NotCanEditItem,
    RejectModal,
    RepeatModal,
    FormatHistoryModal
  },
  mixins: [inquiryFormMixin],
  provide () {
    return {
      myForm: this.form
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      formData: this.data,
      form: this.$form.createForm(this),
      currentFrom: '',

      // 拒审数据
      showRejectModal: false,
      rejectAuditRoleid: 0,
      rejectAuditGroupid: 0,
      // 查重数据
      showRepeatModal: false,
      repeatData: [],

      // 编辑时保存的类型
      saveType: '',

      // 配置里删除的项在编辑里删除
      delfields: [],

      // 编辑保存禁止重复提交
      confirmLoading: false,

      // 查看提交记录
      showFormatHistoryModal: false
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('inquery/detailData', ['joinTeamCascaderShow']),
    ...mapState('inquery/relateData', ['recycleRuleTips']),
    ...mapGetters('inquery/detailData', ['memberInfo', 'permissionInfo']),

    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    inquiryId () {
      return this.$route.params.inquiryId
    },
    hideContent () {
      if (this.from === 'audit' || !this.permissionInfo) return false

      return !this.permissionInfo.is_show_inquirydetail && !this.permissionInfo.is_show_fromdetail && !this.permissionInfo.is_show_followups && !this.permissionInfo.is_show_comments && !this.permissionInfo.is_show_historys
    },
    /* fromInfoChild () {
      const { from_info: fromInfo = {} } = this.formData || {}
      const { child = [] } = fromInfo
      return child
    },
    fromNotEditItem () {
      let { fieldvalue, childObj = {} } = this.formData.from_info || {}
      let obj = {}
      obj.fieldvalue = (fieldvalue && childObj[fieldvalue] && childObj[fieldvalue].fieldname) || ''
      obj.fieldname = this.formData.from_info.fromname || ''
      obj.fieldtype = 'string'
      return obj
    }, */
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    showPassTab () {
      let flag = false
      if (this.from === 'audit') {
        flag = false
      } else {
        if (this.auditStatus === 0 || this.auditStatus === -1) {
          flag = false
        } else if (this.auditStatus === 1) { // 通过
          flag = true
        }
      }
      return flag
    },
    showFooter () {
      if (!this.permissionInfo) return false

      return this.permissionInfo.is_show_approval ||
        this.permissionInfo.is_show_reject ||
        (!this.showPassTab && this.permissionInfo.is_show_reapproval) ||
        this.permissionInfo.is_show_save ||
        (!this.showPassTab && this.permissionInfo.is_show_del) ||
        this.permissionInfo.is_show_compare
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    formHistoryId () {
      const { form_history_id: formHistoryId } = this.memberInfo
      return formHistoryId
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  /* watch: {
    formData: {
      handler (val) {
        const { base_info: baseInfo = {} } = val || {}
        if (!baseInfo || !baseInfo.child || !val.deal_info) return

        for (let i in val) {
          let item = val[i]
          this.$set(item, 'show', true)
        }

        const infoStatus = baseInfo.child.find(
          item => item.fieldkey === 'info_status'
        )

        if (!infoStatus || !infoStatus.options) return

        const dealStatusItem = infoStatus.options.find(
          item => item.name === this.$t('message["109"]')
        ) || {}
        const res = dealStatusItem && dealStatusItem.id === infoStatus.fieldvalue

        this.$set(val.deal_info, 'show', res)
      },
      immediate: true
    }
  }, */
  async created () {
    /* if (this.formData && this.formData.from_info && this.formData.from_info.fieldvalue) {
      this.currentFrom = this.formData.from_info.fieldvalue
    } else {
      this.currentFrom = this.fromInfoChild[0] && this.fromInfoChild[0].id
    } */
    // this.$bus.$on('dealShow', this.setDealShow)
  },
  methods: {
    ...mapActions('inquery/detailData', ['deleteDetail']),
    ...mapActions('inquery/relateData', ['fetchRecycleLogTip']),

    getLang,

    hideModule (k) {
      let { isDeal, isInvalid, isDiscard } = this
      return (k === 'deal_info' && !isDeal) || (k === 'invalid_info' && !isInvalid) || (k === 'discard_info' && !isDiscard)
    },

    /* setDealShow (item = {}) {
      // console.log(item.fieldvalue)
      const show = this.dealShow(item.fieldvalue)

      if (this.formData && this.formData.deal_info) {
        this.$set(this.formData.deal_info, 'show', show)
      }
    }, */
    /* dealShow (val) {
      const { base_info: baseInfo } = this.formData || {}
      if (!baseInfo || !baseInfo.child) return

      const infoStatus = baseInfo.child.find(item => item.fieldkey === 'info_status')

      if (!infoStatus || !infoStatus.options) return

      const dealStatusItem = infoStatus.options.find(
        item => item.name === this.$t('message["109"]')
      ) || {}
      const res = dealStatusItem.id === (val || infoStatus.fieldvalue)

      return res
    }, */
    /**
     * 切换信息来源：网站，电话，邮箱等
     */
    /* handleChangeFromSource (val, data) {
      if (!this.formData || !this.formData.from_info) return

      for (let item of this.fromInfoChild) {
        if (item.id === val) {
          this.formData.from_info.fieldvalue = item.fieldkey
          this.currentFrom = item.fieldkey
        }
      }
      this.relateTeamInfo(this.formData.from_info)
    }, */

    /**
     * 删除配置里更改的表单项
     */
    handleDeleteItem (modulesData, fieldkey) {
      if (modulesData && modulesData.fieldkey === 'from_info' && modulesData.childObj && modulesData.childObj[this.currentFrom]) {
        let childData = modulesData.childObj[this.currentFrom].child

        childData.forEach((item, i) => {
          if (fieldkey === item.fieldkey) {
            childData.splice(i, 1)
            this.delfields.push(fieldkey)
          }
        })

        // this.formData.from_info.childObj[this.currentFrom].child = childData
      } else {
        if (!modulesData.child) return

        modulesData.child.forEach((item, i) => {
          if (fieldkey === item.fieldkey) {
            modulesData.child.splice(i, 1)
            this.delfields.push(fieldkey)
          }
        })
        this.$forceUpdate()
      }
    },
    againSaveForm ({ saveType, checkrepeatconfirm }) {
      this.handleSubmit(saveType, checkrepeatconfirm)
    },

    /**
     * 点击拒审, 通过，保存时，获取拒审人员（所属团队/组）的 id
     */
    getGroupMember () {
      let { info = {} } = this.formData || {}
      let { child = [] } = info
      for (let item of child) {
        const { fieldkey, info: itemInfo = {} } = item
        if (fieldkey === 'group') {
          this.rejectAuditRoleid = itemInfo.roleid
          this.rejectAuditGroupid = itemInfo.groupid
        }
      }
      this.form.resetFields()

      // 如果是负责人/所属团队小组选项没有值，拒审时所属团队小组非必填
      if ((this.baseinfo && this.baseinfo.system_role === 1) || !this.joinTeamCascaderShow || (this.rejectAuditRoleid && this.rejectAuditGroupid)) {
        return false
      } else {
        this.form.validateFields(['group'], { force: true })
        return true
      }
    },
    /**
     * 拒审提交接口
     */
    async confirmReject (saveType) {
      let error = this.getGroupMember()
      if (!error) {
        this.showRejectModal = true
      }
    },
    /**
     * 点击保存，通过，再次通过，拒审等按钮
     * saveType：类型：save，pass，reject
     * checkrepeatconfirm: 1是点击了查重弹窗的继续保存
     */
    async handleSubmit (saveType, checkrepeatconfirm) {
      this.$bus.$emit('myQuillEditorBlur')

      this.form.validateFields(async (err, values) => {
        err = this.checkError(err)
        if (!err) {
          if (this.confirmLoading) return

          this.confirmLoading = true

          const formData = await this.setFormDataParams(this.formData)
          let params = {
            inquiryid: this.inquiryId,
            ...formData,
            delfields: this.delfields
          }
          if (checkrepeatconfirm === 1) {
            params.checkrepeatconfirm = checkrepeatconfirm
          }

          await this.comfirmForm(saveType, params)
        }
      })
    },

    /**
     * params: 处理过的表单数据作为保存参数
     */
    async comfirmForm (saveType, params) {
      let chain
      let _this = this
      // 查重详情额外加参数
      if (this.from === 'checkrepeat' && this.checkrepeatfieldkey) {
        params.scope = this.from
        params.checkrepeatfieldkey = this.checkrepeatfieldkey
      }
      if (saveType === 'save') { // 点击保存按钮
        chain = await inquiryEdit()
        chain
          .onSuccess(() => {
            // 如果回收提示有值，返回列表
            if (this.recycleRuleTips) {
              let timer = null
              clearTimeout(timer)
              timer = setTimeout(() => {
                this.$router.push({
                  name: 'InqueryList',
                  query: {
                    type: this.type,
                    from: this.from
                  }
                })
              }, 2000)
            } else {
              // 保存成功更新详情接口
              eventBus.$emit('fetchInquiryDetail', this.inquiryId, 'save')
              this.form.resetFields()
              // 获取询盘规则重置后的提示说明
              this.fetchRecycleLogTip({
                inquiryid: this.inquiryId
              })
            }
          })
          .onNetSuccess(raw => {
            this.confirmLoading = false
            const { data } = raw
            if (data.error === 104) { // 有重复
              this.showRepeatModal = true
              this.repeatData = data.payload
            }
          })
          .config({
            error104: false,
            error100 (raw) {
              let msg = ''
              if (raw.message) {
                msg = raw.message
              } else if (raw.payload && raw.payload.length) {
                msg = raw.payload[0]
              }
              _this.$message.destroy()
              _this.$message.error(msg)
            }
          })
          .params(params).fetch()
      } else if (saveType === 'pass') { // 点击通过/重新通过按钮
        chain = await inquiryApproval()
        chain
          .onSuccess(() => { // 保存成功跳转到待审核列表
            if (this.from === FROM_SOPURCE) {
              this.$router.push({ name: 'recordNotice' })
            } else if (this.from === 'webhook') {
              this.$router.push({
                name: 'configSendRecord',
                params: {
                  hookid: this.$route.query.hookid
                }
              })
            } else if (this.from === 'clue') {
              this.$router.push({
                name: 'InqueryClue',
                params: {
                  id: this.$route.query.clue_id
                }
              })
            } else if (this.from === 'ocpc') {
              this.$router.push({
                name: 'ocpc'
              })
            } else if (this.from && !this.type) {
              this.$router.go(-1)
            } else {
              if (this.from === 'audit') {
                this.$router.push({
                  name: 'InqueryAudit',
                  query: {
                    type: this.type || 'wait-audit',
                    from: this.from
                  }
                })
              } else {
                this.$router.push({
                  name: 'InqueryList',
                  query: {
                    type: this.type,
                    from: this.from
                  }
                })
              }
              this.form.resetFields()
            }
          })
          .onNetSuccess(raw => {
            this.confirmLoading = false
            const { data } = raw
            if (data.error === 104) { // 有重复
              this.showRepeatModal = true
              this.repeatData = data.payload
            }
          })
          .config({
            error104: false,
            error100 (raw) {
              let msg = ''
              if (raw.message) {
                msg = raw.message
              } else if (raw.payload && raw.payload.length) {
                msg = raw.payload[0]
              }
              _this.$message.destroy()
              _this.$message.error(msg)
            }
          })
          .params(params).fetch()
      }
    },

    /**
     * 删除询盘
     */
    async handleDelete () {
      this.$confirm({
        title: this.$t('message["493"]'),
        content: this.$t('message["969"]') + '？',
        okText: this.$t('message["915"]'),
        okType: 'danger',
        cancelText: this.$t('message["896"]'),
        onOk: async () => {
          const chain = await this.deleteDetail()
          chain
            .onSuccess((raw, res) => {
              if (!res.error) {
                let name = ''
                if (this.from === 'audit') {
                  name = 'InqueryAudit'
                } else if (this.from === 'checkrepeat') {
                  name = 'InqueryRepeat'
                } else {
                  name = 'InqueryList'
                }
                if (this.from && this.type) {
                  this.$router.push({
                    name,
                    query: {
                      type: this.type,
                      from: this.from
                    }
                  })
                } else if (this.from === FROM_SOPURCE) {
                  this.$router.push({ name: 'recordNotice' })
                } else if (this.from === 'webhook') {
                  this.$router.push({
                    name: 'configSendRecord',
                    params: {
                      hookid: this.$route.query.hookid
                    }
                  })
                } else if (this.from === 'clue') {
                  this.$router.push({
                    name: 'InqueryClue',
                    params: {
                      id: this.$route.query.clue_id
                    }
                  })
                } else if (this.from === 'ocpc') {
                  this.$router.push({
                    name: 'ocpc'
                  })
                } else {
                  this.$router.go(-1)
                }
              }
            })
            .params({
              inquiryid: this.inquiryId
            })
            .fetch()
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    },
    // 查看提交记录
    handleFormatHistory () {
      this.showFormatHistoryModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  position: relative;
  height: 100%;
  .containerScroll {
    height: 100%;
    overflow-y: scroll;
    margin-right: -40px;
    padding: 24px 64px 64px 0;
  }
  .module {
    padding-bottom: 40px;
    .title {
      margin-bottom: 0;
    }
    .recycle-rule-tips {
      padding-bottom: 12px;
    }
  }
  .footer-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 90;
    width: 100%;
    height: 64px;
  }
  .footer {
    height: 64px;
    margin: 0 -40px;
    padding: 16px 0 16px 180px;
    background-color: #fff;
    border-top: solid 1px $gray4;
    border-radius: 0 0 0 4px;
    .format-history {
      float: right;
      margin-right: 24px;

      .prompt-text {
        color: #f6a953;
        font-size: 14px;
      }
    }
    .format-history-btn {
      margin-left: 20px;
    }
  }
}
.en-form::v-deep {
  .ant-form-item-label {
    width: 200px;
    text-overflow: ellipsis;
    label {
      white-space: nowrap;
    }
  }
  .ant-form-item-control-wrapper {
    padding-left: 200px;
  }
   .ant-form-item-label label::after{
    content: '';
  }
  .ant-form-item-label::after {
    content: ':';
    position: absolute;
    left: 182px;
    top: 0;
    color: #666;
  }
}
</style>
